"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _noop2 = _interopRequireDefault(require("lodash-es/noop"));
var _get2 = _interopRequireDefault(require("lodash-es/get"));
var _debounce2 = _interopRequireDefault(require("lodash-es/debounce"));
var _carouselHelpers = require("./carouselHelpers");
var _constants = require("./constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /* eslint-disable import/no-unresolved */ // libraries
// helpers
var maxDotsInCarousel = 6;
var ScrollableDotSize = 12.5;
var Carousel = function Carousel(props) {
  var componentData = props.componentData,
    DesiredComp = props.componentToRender,
    _props$currentIndex = props.currentIndex,
    currentIndex = _props$currentIndex === void 0 ? 0 : _props$currentIndex,
    _props$moveToIndex = props.moveToIndex,
    moveToIndex = _props$moveToIndex === void 0 ? -1 : _props$moveToIndex,
    autoScroll = props.autoScroll,
    autoScrollTimeout = props.autoScrollTimeout,
    arrowInsetPadding = props.arrowInsetPadding,
    activeRedDots = props.activeRedDots,
    scrollableDots = props.scrollableDots,
    newCarouselDots = props.newCarouselDots,
    activeRedDotsAdjusted = props.activeRedDotsAdjusted;
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    currentWindowFirstIndex = _useState2[0],
    setCurrentWindowFirstIndex = _useState2[1];
  var _useState3 = (0, _react.useState)(maxDotsInCarousel - 1),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    currentWindowLastIndex = _useState4[0],
    setCurrentWindowLastIndex = _useState4[1];
  var _useState5 = (0, _react.useState)(0),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    scrollValue = _useState6[0],
    setScrollValue = _useState6[1];
  var _useState7 = (0, _react.useState)({
      left: false,
      right: false
    }),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    loading = _useState8[0],
    setLoading = _useState8[1];
  var _useState9 = (0, _react.useState)(currentIndex),
    _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
    active = _useState10[0],
    setActive = _useState10[1];
  var _useState11 = (0, _react.useState)(-1),
    _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
    timer = _useState12[0],
    setTimer = _useState12[1];
  var _useState13 = (0, _react.useState)(0),
    _useState14 = (0, _slicedToArray2["default"])(_useState13, 2),
    width = _useState14[0],
    setWidth = _useState14[1];
  var _useState15 = (0, _react.useState)(false),
    _useState16 = (0, _slicedToArray2["default"])(_useState15, 2),
    isDragging = _useState16[0],
    setDragging = _useState16[1];
  var _useState17 = (0, _react.useState)(0),
    _useState18 = (0, _slicedToArray2["default"])(_useState17, 2),
    dragPosition = _useState18[0],
    setInitialPosition = _useState18[1];
  var _useState19 = (0, _react.useState)(0),
    _useState20 = (0, _slicedToArray2["default"])(_useState19, 2),
    dragTransition = _useState20[0],
    setDragTransition = _useState20[1];
  var _useState21 = (0, _react.useState)(false),
    _useState22 = (0, _slicedToArray2["default"])(_useState21, 2),
    disableBtn = _useState22[0],
    setDisableBtn = _useState22[1];
  var _useState23 = (0, _react.useState)(autoScrollTimeout),
    _useState24 = (0, _slicedToArray2["default"])(_useState23, 2),
    timerCount = _useState24[0],
    setTimerCount = _useState24[1];
  var _useState25 = (0, _react.useState)(componentData),
    _useState26 = (0, _slicedToArray2["default"])(_useState25, 2),
    carouselData = _useState26[0],
    setCarouselData = _useState26[1];
  var _useState27 = (0, _react.useState)(true),
    _useState28 = (0, _slicedToArray2["default"])(_useState27, 2),
    showTransition = _useState28[0],
    setTransition = _useState28[1];
  var _useState29 = (0, _react.useState)(props.slidesToShow),
    _useState30 = (0, _slicedToArray2["default"])(_useState29, 2),
    slidesToShow = _useState30[0],
    setSlidesToShow = _useState30[1];
  var maxDots = Math.ceil((carouselData.length - slidesToShow) / props.slidesToScroll) + 1;
  var hideLeftArrow = props.hideLeftArrow || !props.infinite && active === 0;
  var hideRightArrow = props.hideRightArrow || !props.infinite && active === maxDots - 1;
  var node = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    setCarouselData(componentData);
  }, [componentData]);
  (0, _react.useEffect)(function () {
    props.arrowClicked(_objectSpread(_objectSpread(_objectSpread({}, componentData[active]), props.commonProps), {}, {
      index: active
    }));
    if (maxDots > maxDotsInCarousel && scrollableDots) {
      if (currentWindowFirstIndex === active && active !== 0) {
        setScrollValue(scrollValue + ScrollableDotSize);
        setCurrentWindowFirstIndex(active - 1);
        setCurrentWindowLastIndex(currentWindowLastIndex - 1);
      } else if (currentWindowLastIndex === active && active !== maxDots - 1) {
        setScrollValue(scrollValue - ScrollableDotSize);
        setCurrentWindowFirstIndex(currentWindowFirstIndex + 1);
        setCurrentWindowLastIndex(active + 1);
      } else if (active === 0) {
        setCurrentWindowFirstIndex(0);
        setCurrentWindowLastIndex(5);
        setScrollValue(0);
      } else if (active + 1 === maxDots) {
        setCurrentWindowFirstIndex(maxDots - 6);
        setCurrentWindowLastIndex(maxDots - 1);
        setScrollValue((maxDots - 6) * -ScrollableDotSize);
      }
    }
  }, [active]);
  var updateCarouselState = function updateCarouselState() {
    var isLeft = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return function (data) {
      if (Array.isArray(data) && data.length > 0) {
        setTransition(false);
        var updatedData = isLeft ? [].concat((0, _toConsumableArray2["default"])(data), (0, _toConsumableArray2["default"])(carouselData)) : [].concat((0, _toConsumableArray2["default"])(carouselData), (0, _toConsumableArray2["default"])(data));
        var startingDelIndex = isLeft ? updatedData.length - props.slidesToLoad : 0;
        updatedData.splice(startingDelIndex, props.slidesToLoad);
        setCarouselData(updatedData);
        isLeft ? setActive(props.slidesToLoad - 1) : setActive(active - props.slidesToLoad + 1);
        setTimeout(function () {
          return setTransition(true);
        }, 300);
      }
      setLoading({
        left: false,
        right: false
      });
    };
  };
  var clickHandler = function clickHandler(newActive, cb, isLeft) {
    var oldActive = active;
    var doAutoLoad = !!props.slidesToLoad && typeof cb === "function";
    if (doAutoLoad && (oldActive === 0 && isLeft || oldActive === maxDots - 1 && !isLeft)) {
      setLoading({
        left: !!isLeft,
        right: !isLeft
      });
      cb(updateCarouselState(isLeft));
    } else {
      setActive(newActive);
    }
    setDisableBtn(true);
    setTimeout(function () {
      return setDisableBtn(false);
    }, 500);
  };
  var onRightClick = function onRightClick(_) {
    if (!disableBtn) {
      var newActive = !!props.slidesToLoad ? active + 1 : Math.floor((active + 1) % maxDots);
      clickHandler(newActive, newActive === maxDots ? props.getNext : _noop2["default"]);
    }
  };
  var onLeftClick = function onLeftClick(_) {
    if (!disableBtn) {
      var newActive = Math.ceil(active === 0 ? maxDots - 1 : active - 1);
      clickHandler(newActive, newActive === maxDots - 1 ? props.getPrev : _noop2["default"], true);
    }
  };
  var _onTouchStart = function _onTouchStart(e) {
    setDragging(true);
    setInitialPosition(e.touches[0].pageX);
  };
  var _onTouchEnd = function _onTouchEnd(e) {
    setDragging(false);
    if (dragTransition < 0 && Math.abs(dragTransition) > width / 10) {
      setActive(Math.ceil(active === 0 ? maxDots - 1 : active - 1));
    }
    if (dragTransition > 0 && Math.abs(dragTransition) > width / 10) {
      setActive(Math.floor((active + 1) % maxDots));
    }
    setInitialPosition(0);
    setDragTransition(0);
  };
  var _onTouchMove = function _onTouchMove(e) {
    var dragTrans = dragPosition - e.touches[0].pageX;
    var canDrag = dragTrans < 0 && !hideLeftArrow || dragTrans > 0 && !hideRightArrow;
    if (isDragging && canDrag) {
      setDragTransition(dragTrans);
    }
  };
  var onDotClick = function onDotClick(index) {
    return function (e) {
      clickHandler(index);
    };
  };
  var calibrateForScreen = function calibrateForScreen() {
    setWidth((0, _get2["default"])(node, "current.clientWidth", 0));
    if (props.isResponsive && window && window.innerWidth) {
      /**
       * Calculating window innerWidth always causes reflow
       * hence run below code only when
       * dev has specifically asked for a respnsive carousel.
       */
      var screenWidth = window.innerWidth;
      switch (true) {
        case screenWidth > 480 && screenWidth <= 768:
          setSlidesToShow(props.slidesToShowTab);
          break;
        case screenWidth <= 480:
          setSlidesToShow(props.slidesToShowMobile);
          break;
        default:
          setSlidesToShow(props.slidesToShow);
          break;
      }
    }
  };

  // requires @use-it/event-listener
  // useEventListener("resize", _debounce(calibrateForScreen, 100));
  (0, _react.useLayoutEffect)(function () {
    setWidth(node.current.clientWidth);
    typeof calibrateForScreen === "function" && calibrateForScreen();
    window && window.addEventListener && window.addEventListener("resize", (0, _debounce2["default"])(calibrateForScreen, 100));
  }, []);
  var autoPlay = function autoPlay() {
    clearTimeout(timer);
    if (timerCount) {
      var timerIndex = setTimeout(function () {
        setActive(Math.floor((active + 1) % maxDots));
      }, timerCount);
      setTimer(timerIndex);
    }
  };
  (0, _react.useLayoutEffect)(function () {
    props.onSlideChange(active);
    !disableBtn && moveToIndex > -1 && setActive(moveToIndex);
    if (autoScroll) {
      autoPlay();
    }
  }, [moveToIndex, active, timerCount]);
  var getTransitionWidth = function getTransitionWidth() {
    var wrapperWidth = slidesToShow === 1 ? width : width + props.innerMargin;
    return wrapperWidth * active * props.slidesToScroll / slidesToShow;
  };
  var mouseEnterHandler = function mouseEnterHandler() {
    setTimerCount(0);
  };
  var mouseLeaveHandler = function mouseLeaveHandler() {
    setTimerCount(autoScrollTimeout);
  };
  var handleKeyPress = function handleKeyPress(e) {
    switch (e.keyCode) {
      case 37:
        //move to left
        if (typeof onLeftClick === "function" && !hideLeftArrow) onLeftClick();
        break;
      case 39:
        //move to right
        if (typeof onRightClick === "function" && !hideRightArrow) onRightClick();
        break;
      case 36:
        //Home : move to First slide
        e.stopPropagation();
        e.preventDefault();
        clickHandler(0);
        break;
      case 35:
        //End : move to Last slide
        e.stopPropagation();
        e.preventDefault();
        clickHandler(maxDots - 1);
        break;
      default:
        break;
    }
  };
  return /*#__PURE__*/_react["default"].createElement(SliderElementWrapper, {
    wrapperWidth: props.wrapperWidth,
    tabIndex: 0,
    onKeyDown: handleKeyPress,
    "aria-roledescription": "carousel"
  }, /*#__PURE__*/_react["default"].createElement(SliderElement, {
    showComponents: props.showComponents,
    carouselWidth: props.carouselWidth,
    ref: node,
    onMouseEnter: mouseEnterHandler,
    onMouseLeave: mouseLeaveHandler
  }, /*#__PURE__*/_react["default"].createElement(SlidesWrapper, null, /*#__PURE__*/_react["default"].createElement(Slides, {
    componentCount: carouselData.length,
    transitionWidth: getTransitionWidth() + dragTransition,
    slidesToScroll: Math.min(props.slidesToScroll, slidesToShow),
    totalWidth: width,
    "aria-live": autoScroll ? "off" : "polite",
    showTransition: showTransition
  }, carouselData.map(function (data, index) {
    return /*#__PURE__*/_react["default"].createElement(DesiredCompWrapper, {
      className: "carousel-content",
      "aria-roledescription": "slide",
      key: "slide_".concat(index),
      height: props.height,
      slidesToShow: slidesToShow,
      totalWidth: width,
      onTouchStart: _onTouchStart,
      onTouchMove: _onTouchMove,
      onTouchEnd: _onTouchEnd,
      mobileHeight: props.mobileHeight,
      totalMargin: props.innerMargin * (slidesToShow - 1),
      margin: slidesToShow === 1 ? 0 : "".concat(props.innerMargin, "px")
    }, /*#__PURE__*/_react["default"].createElement(DesiredComp, (0, _extends2["default"])({}, data, props.commonProps, {
      index: index,
      isActive: index === active,
      total: carouselData.length,
      "aria-label": "".concat(index + 1, " of ").concat(carouselData.length)
    })));
  }))), !hideLeftArrow && (0, _carouselHelpers.renderArrow)(onLeftClick, props.defaultTheme, props.forceArrowVisible, props.arrowFromTop, props.mobileArrowFromTop, props.mobileArrowHidden, props.arrowHidden, props.tabArrowHidden, props.isPhotoViewer, _constants.LEFT_ARROW, loading.left, props.arrowClassName, arrowInsetPadding), !hideRightArrow && (0, _carouselHelpers.renderArrow)(onRightClick, props.defaultTheme, props.forceArrowVisible, props.arrowFromTop, props.mobileArrowFromTop, props.mobileArrowHidden, props.arrowHidden, props.tabArrowHidden, props.isPhotoViewer, _constants.RIGHT_ARROW, loading.right, props.arrowClassName, arrowInsetPadding)), (0, _carouselHelpers.dotRenderer)(props.dots && !props.slidesToLoad, maxDots, onDotClick, active, props.insideDots, activeRedDots, scrollableDots, scrollValue, currentWindowFirstIndex, currentWindowLastIndex, newCarouselDots, activeRedDotsAdjusted));
};
var SliderElementWrapper = /*#__PURE__*/_styledComponents["default"].section.withConfig({
  componentId: "sc-w2q7gn-0"
})(["position:relative;width:", ";&:hover .carousel-arrow{visibility:visible;}&:focus{outline:none;}"], (0, _carouselHelpers.getAttributes)("wrapperWidth"));
var DesiredCompWrapper = /*#__PURE__*/_styledComponents["default"].section.withConfig({
  componentId: "sc-w2q7gn-1"
})(["height:", ";width:", "px;margin-right:", ";@media (max-width:480px){height:", ";}"], (0, _carouselHelpers.getAttributes)("height"), _carouselHelpers.getComponentWrapperWidth, function (props) {
  return props.margin;
}, (0, _carouselHelpers.getAttributes)("mobileHeight") || (0, _carouselHelpers.getAttributes)("height"));
var Slides = /*#__PURE__*/_styledComponents["default"].section.withConfig({
  componentId: "sc-w2q7gn-2"
})(["touch-action:manipulation;display:flex;position:relative;overflow:hidden;width:", ";transform:", ";transition:", ";"], _carouselHelpers.getTrackWidth, _carouselHelpers.getTransform, function (props) {
  return props.showTransition ? "transform 0.45s ease-in-out 0s" : "none";
});
var SlidesWrapper = /*#__PURE__*/_styledComponents["default"].section.withConfig({
  componentId: "sc-w2q7gn-3"
})(["overflow:hidden;"]);
var SliderElement = /*#__PURE__*/_styledComponents["default"].section.withConfig({
  componentId: "sc-w2q7gn-4"
})(["position:relative;display:flex;.text-size{font-size:1.4rem;}width:", ";"], (0, _carouselHelpers.getAttributes)("carouselWidth"));
Carousel.propTypes = {
  componentData: _propTypes["default"].array.isRequired,
  componentToRender: _propTypes["default"].func.isRequired,
  height: _propTypes["default"].string,
  mobileHeight: _propTypes["default"].string,
  mobileArrowHidden: _propTypes["default"].bool,
  tabArrowHidden: _propTypes["default"].bool,
  arrowHidden: _propTypes["default"].bool,
  carouselWidth: _propTypes["default"].string,
  arrowFromTop: _propTypes["default"].string,
  mobileArrowFromTop: _propTypes["default"].string,
  wrapperWidth: _propTypes["default"].string,
  dots: _propTypes["default"].bool,
  insideDots: _propTypes["default"].bool,
  slidesToShow: _propTypes["default"].number,
  slidesToScroll: _propTypes["default"].number,
  /** Whether the carousel is responsive. Maintaining carousel state for diffrent screen widths is highly expensive.*/
  isResponsive: _propTypes["default"].bool,
  showComponents: _propTypes["default"].bool,
  /** Ignored when isResponsive is false/ not specified, Number of slides to be shown on Tab screens (i.e screens less than 768px wide but more than 480px)  */
  slidesToShowTab: _propTypes["default"].number,
  /** Ignored when isResponsive is false/ not specified, Number of slides to be shown on MObile screens (i.e screens less than 480px wide)  */
  slidesToShowMobile: _propTypes["default"].number,
  defaultTheme: _propTypes["default"].bool,
  infinite: _propTypes["default"].bool,
  moveToIndex: _propTypes["default"].number,
  autoScroll: _propTypes["default"].bool,
  onSlideChange: _propTypes["default"].func,
  autoScrollTimeout: _propTypes["default"].number,
  currentIndex: _propTypes["default"].number,
  scrollableDots: _propTypes["default"].bool,
  isPhotoViewer: _propTypes["default"].bool,
  commonProps: _propTypes["default"].object,
  innerMargin: _propTypes["default"].number,
  slidesToLoad: _propTypes["default"].number,
  getNext: _propTypes["default"].func,
  getPrev: _propTypes["default"].func,
  hideLeftArrow: _propTypes["default"].bool,
  hideRightArrow: _propTypes["default"].bool,
  arrowClassName: _propTypes["default"].string,
  /** Add padding to the arrows to push them inside the carousel */
  arrowInsetPadding: _propTypes["default"].string,
  forceArrowVisible: _propTypes["default"].bool,
  arrowClicked: _propTypes["default"].func,
  /* Justify-content: flex-start instead of center */
  newCarouselDots: _propTypes["default"].bool,
  /* Aligns centrally the highlighted red dot of activeRedDot */
  activeRedDotsAdjusted: _propTypes["default"].bool
};
Carousel.defaultProps = {
  height: "auto",
  carouselWidth: "100%",
  dots: true,
  insideDots: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  slidesToShowTab: 1,
  slidesToShowMobile: 1,
  isResponsive: false,
  autoScroll: false,
  onSlideChange: _noop2["default"],
  defaultTheme: true,
  infinite: true,
  mobileArrowHidden: false,
  arrowHidden: false,
  tabArrowHidden: false,
  autoScrollTimeout: 3000,
  currentIndex: 0,
  isPhotoViewer: false,
  scrollableDots: false,
  commonProps: {},
  innerMargin: 0,
  loadOnDemand: false,
  slidesToLoad: 0,
  getNext: _noop2["default"],
  getPrev: _noop2["default"],
  hideLeftArrow: false,
  hideRightArrow: false,
  arrowClassName: "carousel-arrow",
  arrowInsetPadding: "0",
  forceArrowVisible: false,
  arrowClicked: _noop2["default"],
  newCarouselDots: false,
  activeRedDotsAdjusted: false
};
var _default = exports["default"] = Carousel;